import { combineReducers } from 'redux';

import common from '@store/common/reducer';
import filterContainer from '@store/filterContainer/reducer';

export default () =>
  combineReducers({
    filterContainer,
    common,
  });
